import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, PageHero } from '../components/bits';

const CONTENT = {
  privacy: {
    title: 'Privacy Policy',
    body: [
      'DITEC (Digital Intelligence & Technology Excellence Council) collects only the information you voluntarily submit through our enquiry and contact forms — such as your name, organisation, email, phone number and area of interest.',
      'This information is used solely to respond to your enquiry, share programme or partnership details you requested, and manage the relationship you initiated with us.',
      'We do not sell, rent or share your personal information with third parties for their marketing purposes. Data is stored securely and access is restricted to authorised DITEC team members.',
      'You may request access to, correction of, or deletion of your data at any time by writing to ditec.org@gmail.com.',
    ],
  },
  terms: {
    title: 'Terms & Conditions',
    body: [
      'The content on this website is provided by DITEC for general information about its ecosystem, programmes and enterprise services.',
      'Programme structures, scholarship details, dates and eligibility criteria are subject to official confirmation and may be updated. Where scenarios or examples are shown, they are illustrative and do not constitute guarantees of outcomes, earnings or returns.',
      'DITEC is not positioned as a conventional job-guarantee programme. References to monetization, freelancing or commercial activity describe curriculum components, not promised results.',
      'By submitting a form on this website, you consent to being contacted by the DITEC team regarding your enquiry.',
    ],
  },
  cookies: {
    title: 'Cookie Policy',
    body: [
      'This website uses a minimal set of cookies and similar technologies required for core functionality and privacy-respecting usage analytics.',
      'Analytics information is aggregated and used only to understand how the website is used so we can improve it. It is not used to build advertising profiles.',
      'You can control or delete cookies through your browser settings at any time; the website will continue to function for browsing without them.',
    ],
  },
  ethics: {
    title: 'Digital Ethics / Responsible AI',
    body: [
      'DITEC treats ethical behaviour as a core capability dimension — it is embedded in our DRIVE assessment model and across the curriculum.',
      'AI is taught and used as a productivity layer that augments human judgment, not a replacement for accountability, originality or professional responsibility.',
      'We are committed to transparent labelling: simulated, modelled or hypothetical examples are always identified as such, and learner evidence presented through the ecosystem reflects genuine work.',
      'Questions about our responsible-AI approach can be directed to ditec.org@gmail.com.',
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid={`legal-${kind}`}>
      <SEO title={c.title} description={c.body[0]} />
      <PageHero tag="Legal" lines={<>{c.title}</>} />
      <section className="bg-paper py-16 sm:py-24">
        <div className="wrap max-w-3xl space-y-8">
          {c.body.map((p, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="flex gap-6 border-t border-navy/10 pt-8">
                <span className="font-mono text-xs text-electric">0{i + 1}</span>
                <p className="text-base leading-relaxed text-navy/75">{p}</p>
              </div>
            </Reveal>
          ))}
          <SectionTag>Last updated — July 2026</SectionTag>
        </div>
      </section>
    </div>
  );
}
